module.exports = __webpack_public_path__ + "img/laboratorio2_3-4_2304.6fdd0bfd.webp";